module.exports = __webpack_public_path__ + "img/yeYaBeng2.98a672e6.png";